import { render, staticRenderFns } from "./codeMaintain.vue?vue&type=template&id=21641bfa&scoped=true"
import script from "./codeMaintain.vue?vue&type=script&lang=js"
export * from "./codeMaintain.vue?vue&type=script&lang=js"
import style0 from "./codeMaintain.vue?vue&type=style&index=0&id=21641bfa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21641bfa",
  null
  
)

export default component.exports